module.exports = __webpack_public_path__ + "img/selbsterfahrung_1280.f288080f.webp";